import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  PM_DASHBOARD,
  FETCH_SITES_GATES,
  
} from './type';

export const fetchPmDashboard = (filterData = null, page = 1) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.maintenance.fetchPmDashboard}?page=${page}`
      : `${Config.maintenance.fetchPmDashboard}?status=${filterData.status}&site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_id=${filterData.assignee_ids}&fromDate=${filterData.fromDate}&toDate=${filterData.toDate}&page=${page}`
  );
  if (res) {
    const { data } = res;
    // console.log(data.response.data);
    dispatch({
      type: PM_DASHBOARD,
      payload: data.response.data,
    });
    return true;
  }
};

//SITES_AND_GATES
export const fetchSitesAndGates = (filterData = null) => async (dispatch) => { 
  const res = await callWebService(
    callTypes.get,
    "",
    filterData === null
      ? `${Config.maintenance.fetchSitesAndGates}`
      : `${Config.maintenance.fetchSitesAndGates}?status=${filterData.status}&site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_id=${filterData.assignee_ids}&fromDate=${filterData.fromDate}&toDate=${filterData.toDate}`
   // `${Config.maintenance.fetchSitesAndGates}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FETCH_SITES_GATES, payload: data.response.data });
    return data.response.data;
  }
};

